import { jsxs, jsx } from 'react/jsx-runtime';
import { isValidElement } from 'react';
import { twMerge } from '@belong/common';
import { Form } from '../Form/Form.js';
import css from './ButtonSelector.module.css.js';
import { ButtonSelectorItem } from './components/button-selector-item/button-selector-item.js';

const ButtonSelector = props => {
  const {
    error,
    itemHeight = 'small',
    label,
    options,
    itemWidth = 'fluid',
    containerClassName = '',
    itemContainerClassName = '',
    itemClassName = '',
    selectedItemClassName = '',
    errorMessageVisible = false
  } = props;
  // we can't destructure the multiple, value and onChange props because it will
  // destroy the correlations between these props defined in the props discriminated union
  // reference: https://stackoverflow.com/a/69033664
  const handleClick = (selectedValue, isSelected) => () => {
    if (!props.multiple) {
      props.onChange(selectedValue);
      return;
    }
    const valueWithDefault = Array.isArray(props.value) ? props.value : [];
    const newValue = isSelected ? valueWithDefault.filter(v => v !== selectedValue) : [...valueWithDefault, selectedValue];
    props.onChange(newValue);
  };
  return jsxs("div", {
    children: [label && jsx("label", {
      className: "mb-sm block font-semibold",
      children: label
    }), jsx("div", {
      className: twMerge('gap-2sm', 'flex flex-col md:flex-row', containerClassName),
      children: options.map((option, optionIndex) => {
        const isSelected = props.multiple && Array.isArray(props.value) ? props.value.includes(option.value) : props.value === option.value;
        return jsxs("div", {
          className: twMerge('relative', itemWidth === 'fluid' ? 'w-full' : 'w-auto', itemContainerClassName),
          children: [option.tag && jsx("span", {
            className: twMerge('absolute left-0 right-0 w-min mx-auto px-xs rounded-small bg-green text-white text-p1 whitespace-nowrap translate-y-[6px]', css.tagMarginTop, option.tagClassName),
            children: option.tag
          }), jsx(ButtonSelectorItem, {
            disabled: option.disabled,
            error: error,
            height: itemHeight,
            onClick: handleClick(option.value, isSelected),
            selected: isSelected,
            selectedClassName: selectedItemClassName,
            width: itemWidth,
            className: itemClassName,
            children: /*#__PURE__*/isValidElement(option.content) ? option.content : option.renderContent ? option.renderContent(isSelected) : option.label
          }), option?.hint && isSelected && jsx("div", {
            className: "mt-sm rounded border border-solid border-green bg-lighter-green/10 p-sm md:mb-xl md:hidden",
            children: jsx("p", {
              className: "leading-p1",
              children: option.hint
            })
          })]
        }, typeof option.label === 'string' ? option.label : optionIndex);
      })
    }), errorMessageVisible && error && jsx(Form.ErrorMessage, {
      message: error
    })]
  });
};

export { ButtonSelector };
